export default __webpack_public_path__ + "static/media/bus-long-distance.da8004c1.svg";